import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

export interface DashboardState {
  performanceLastUpdate: string
}

const initialState: DashboardState = {
  performanceLastUpdate: ''
}

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setPerformanceLastUpdate: (state, action: PayloadAction<string>) => {
      state.performanceLastUpdate = action.payload
    }
  }
})

export const performanceLastUpdateSelector = (state: RootState): string => state.dashboard.performanceLastUpdate

export const { setPerformanceLastUpdate } = dashboardSlice.actions

export default dashboardSlice.reducer
